module.exports = __webpack_public_path__ + "img/969.bc202051.gif";